import PropTypes from 'prop-types';
import { useSwipeable } from 'react-swipeable';

const Swipper = ({ children, onSwipedLeft, onSwipedRight }) => {
  const handlers = useSwipeable({
    onSwipedLeft,
    onSwipedRight,
  });

  if (!onSwipedLeft && !onSwipedRight) {
    return children;
  }

  return (
    <div data-testid="mobile-swipper" {...handlers}>
      {children}
    </div>
  );
};

Swipper.propTypes = {
  children: PropTypes.node.isRequired,
  onSwipedLeft: PropTypes.func,
  onSwipedRight: PropTypes.func,
};

export default Swipper;
